import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash-es';
@Pipe({
    name: "capitalizeFirstLetter",
    standalone: true
})
export class CapitalizeFirstLetter implements PipeTransform{
    transform(value: string, formatting?: string, skipPipe = false): string {
      let formattedStr = value;
      if(!formatting && !skipPipe && !isEmpty(formattedStr)){
        let words = value.toLowerCase().trim().split(' ').filter(word=> !isEmpty(word));
        words = words.map(a=> a =a.replace(a[0],a[0].toUpperCase()));
        formattedStr = words.join(' ');
      }
      return formattedStr;
    }

}
